<template>
  <div v-if="clinic.country_id == countries.RUSSIA"
       class="form-group"
       :class="{ hasErrors }">
    <div class="row justify-content-around">
      <div class="col">
        <label class="form-label"
               :data-content="$t(field.title)">
          {{ $t(field.title) }}
          <span v-if="required"> *</span>
        </label>
      </div>
      <div class="col-auto">
        <div v-if="object[field.id]">
          <div v-if="isValid"><TickSvg class="svg-primary svg-size-lg"/></div>
          <div v-if="!isValid"><WarningSvg class="svg-red"/></div>
        </div>
      </div>
    </div>

    <SpaceduckMaskInput mask="###-###-### ##"
                        :placeholder="$t('snils')"
                        :readonly="readonly"
                        :model-value="object[field.id]"
                        @update:model-value="object[field.id] = $event"
                        class="form-control"
                        :required="required"/>

    <slot/>

    <ValidationError v-if="showErrors"
                     class="mt-3"
                     :validationId="validationId"/>

  </div>
</template>

<script setup>
import {isValidSnils} from "@/services/snils.helper"
import {computed} from "vue"
import WarningSvg from '@/assets/svg-vue/general/warning.svg'
import TickSvg from '@/assets/svg-vue/form/tick.svg'
import {countries} from "@/dictionaries/dictionary"
import {useStore} from "vuex"
import SpaceduckMaskInput from "@/components/parts/general/SpaceduckMaskInput.vue"
import ValidationError from "@/components/form/ValidationError.vue"

const store = useStore()

const props = defineProps({
  object: {
    type: Object
  },
  selectOptions: {},
  field: {},
  required: {},
  readonly: {
    type: Boolean,
    default: false
  },
  showErrors: {
    type: Boolean,
    default: false
  },
  validationId: {},
  value: {},
  selectModels: {}
})

const clinic = computed(() => store.state.auth.clinic)
const errors = computed(() =>  store.state.datatable.validationErrors)

const isValid = computed(() => {
  return isValidSnils(props.object[props.field.id])
})

const hasErrors = computed(() => {
  if(!props.showErrors || !props.validationId) return false
  return !!errors.value[props.validationId]
})
</script>
